import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'

function MoveInWidthwise({ displayed, height }) {
  const displayedWrapper = useRef(null);
  const container = useRef(null);
  const [containerHeight, setContainerHeight] = useState('0px');
  const [wrapperWidth, setWrapperWidth] = useState(0);
  const [progress, setProgress] = useState(0);
  const {
    innerWidth,
    innerHeight,
    addEventListener,
    removeEventListener
  } = window;

  const updateProgress = () => {
    const { scrollTop } = document.documentElement;
    const containerTop = container.current.offsetTop;
    const containerHeightNumber = container.current.offsetHeight;

    const newProgress =
      ((scrollTop - containerTop) * 100) / (containerHeightNumber - innerHeight);

    setProgress(newProgress);
  };

  useEffect(() => {
    if (!height) {
      setContainerHeight(
        `${
          (innerHeight * displayedWrapper.current.offsetWidth) / innerWidth
        }px`
      );
    } else {
      setContainerHeight(height);
    }
    
    setWrapperWidth(displayedWrapper.current.offsetWidth);
    // eslint-disable-next-line
  }, [height]);

  useEffect(() => {
    window.scrollTo(0, 1);
  }, []);

  useEffect(() => {
    updateProgress();
    addEventListener('scroll', updateProgress);
    return () => {
      removeEventListener('scroll', updateProgress);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        height: containerHeight,
        overflow: 'hidden',
        position: 'relative'
      }}
      ref={container}
    >
      <div
        style={{
          display: 'inline-block',
          height: '100vh',
          transform:
            progress >= 0
              ? progress > 100
                ? `translateX(-${(100 * (wrapperWidth - innerWidth)) /
                    wrapperWidth}%)`
                : `translateX(-${
                    (progress * (wrapperWidth - innerWidth)) / wrapperWidth
                  }%)`
              : 'translateX(0%)',
          position:
            progress <= 100 ? (progress >= 0 ? 'fixed' : 'static') : 'absolute',
          bottom: 0
        }}
        ref={displayedWrapper}
      >
        {displayed}
      </div>
    </div>
  );
}

export function Test() {
  const testComponent = (
    <div style={{ display: 'flex', width: '200vw' }}>
      <div className='block1'>
        <div className='flexCenterCenter all100'>
          <div><FontAwesomeIcon icon={faStar} bounce size="xl" /></div>
          &nbsp;&nbsp;
          <p>test1</p>
        </div>
      </div>
      <div className='block2'>
        <div className='flexCenterCenter all100'>
          <div><FontAwesomeIcon icon={faStar} bounce size="xl" /></div>
          &nbsp;&nbsp;
          <p>test2</p>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <MoveInWidthwise displayed={testComponent} />
    </div>
  );
}
function MoveInWidthwise2({ displayed, height }) {
  const displayedWrapper = useRef(null);
  const container = useRef(null);
  const [containerHeight, setContainerHeight] = useState('0px');
  const [wrapperWidth, setWrapperWidth] = useState(0);
  const [progress, setProgress] = useState(0);
  const {
    innerWidth,
    innerHeight,
    addEventListener,
    removeEventListener
  } = window;

  const updateProgress = () => {
    const { scrollTop } = document.documentElement;
    const containerTop = container.current.offsetTop;
    const containerHeightNumber = container.current.offsetHeight;

    const newProgress =
      ((scrollTop - containerTop) * 100) / (containerHeightNumber - innerHeight);
    setProgress(newProgress);
  };

  useEffect(() => {
    if (!height) {
      setContainerHeight(
        `${
          (innerHeight * displayedWrapper.current.offsetWidth) / innerWidth
        }px`
      );
    } else {
      setContainerHeight(height);
    }
    
    setWrapperWidth(displayedWrapper.current.offsetWidth);
    // eslint-disable-next-line
  }, [height]);

  useEffect(() => {
    window.scrollTo(0, 1);
  }, []);

  useEffect(() => {
    updateProgress();
    addEventListener('scroll', updateProgress);
    return () => {
      removeEventListener('scroll', updateProgress);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        height: containerHeight,
        overflow: 'hidden',
        position: 'relative'
      }}
      ref={container}
    >
      <div
        style={{
          display: 'inline-block',
          height: '100vh',
          transform:
            progress >= 0
              ? progress > 100
                ? `translateX(${(100 * (wrapperWidth - innerWidth)) /
                    wrapperWidth}%)`
                : `translateX(${
                    (progress * (wrapperWidth - innerWidth)) / wrapperWidth
                  }%)`
              : 'translateX(0%)',
          position:
            progress <= 100 ? (progress >= 0 ? 'fixed' : 'static') : 'absolute',
          bottom: 0
        }}
        ref={displayedWrapper}
      >
        {displayed}
      </div>
    </div>
  );
}
export function Test2() {
  const testComponent = (
    <div style={{ display: 'flex', width: '200vw', left: '-100vw', position:'relative' }}>
      <div className='block4'>
        <div className='flexCenterCenter all100'>
          <div><FontAwesomeIcon icon={faStar} bounce size="xl" /></div>
          &nbsp;&nbsp;
          <p>test1</p>
        </div>
      </div>
      <div className='block3'>
        <div className='flexCenterCenter all100'>
          <div><FontAwesomeIcon icon={faStar} bounce size="xl" /></div>
          &nbsp;&nbsp;
          <p>test2</p>
        </div>
      </div>
      {/* <div className='block3'>
        <div className='flexCenterCenter all100'>
          <div><FontAwesomeIcon icon={faStar} bounce size="xl" /></div>
          &nbsp;&nbsp;
          <p>test3</p>
        </div>
      </div>
      <div className='block4'>
        <div className='flexCenterCenter all100'>
          <div><FontAwesomeIcon icon={faStar} bounce size="xl" /></div>
          &nbsp;&nbsp;
          <p>test4</p>
        </div>
      </div> */}
    </div>
  );

  return (
    <MoveInWidthwise2 displayed={testComponent} />
  );
}